// src/supabaseClient.js
import { createClient } from '@supabase/supabase-js';

// Suas credenciais Supabase (mantidas aqui por enquanto)
// No Netlify, estas chaves são consideradas "públicas" (anon key)
// e podem estar no código do frontend.
// Se fossem chaves secretas, usaríamos Netlify Functions.
const SUPABASE_URL = 'https://ofrnrxkatlkggftdgpsq.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9mcm5yeGthdGxrZ2dmdGRncHNxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDkwNjMwMTYsImV4cCI6MjA2NDYzOTAxNn0.1wRm3byZpAqzXU8SlXbpJcJ_WUfytDJ-m_wgAQn9Uho';

// Cria e exporta a instância do cliente Supabase
export const supabaseClient = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);